<script lang="ts" setup>
import { RecommendationBadgeType } from '@/helper/Types'

defineProps<{
  badgeType: RecommendationBadgeType
}>()
</script>

<template>
  <div v-if="badgeType === 'left'" class="recommended-badge">
    <i class="ic-star" />
  </div>

  <div v-else class="top-badge fTable__recommended-badge">
    {{ $t('step_heat_pumps.recommended_badge') }}
  </div>
</template>

<style lang="scss" scoped>
.recommended-badge {
  min-width: auto;
  top: rem-calc(10px);
  left: rem-calc(-14px);
  height: rem-calc(32px);
  width: rem-calc(32px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1;
  color: #fff;

  i {
    font-size: rem-calc(20px);
  }

  @include themify($themes) {
    background-color: themed('secondaryColor');
    &:after {
      content: '';
      bottom: rem-calc(-7px);
      left: 0;
      z-index: 1;
      width: 0;
      height: 0;
      position: absolute;
      border-left: rem-calc(14px) solid transparent;
      border-top: rem-calc(7px) solid themed('secondaryDarkColor');
    }
  }
}
</style>
